import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types';
import s from './index.css';
import qqIcon from './qq.png';
import weixinIcon from './weixin.png';
import weiboIcon from './weibo.png';
import mailIcon from './mail.png'
import { THIRD_LOGIN } from '../../../config';
import { YDLogin } from '../../../core/commonLogin';
import { trackEventLog } from '../../../core/utils'

function ThirdBtn(props) {
  return (
    <div // eslint-disable-line
      className={s.btn}
      onClick={props.handler}
    >
      <img src={props.imgUrl} alt={THIRD_LOGIN.qq.name} />
    </div>
  )
}

ThirdBtn.propTypes = {
  handler: PropTypes.func.isRequired,
  imgUrl: PropTypes.string.isRequired,
}

const LOGIN_LOG = {
  mail: 'MailLogin',
  cqq: 'QQLogin',
  weibo: 'WeiboLogin',
  'weixin-web-xue': 'WeChatLogin',
}

function log(type) {
  trackEventLog(LOGIN_LOG[type])
}

class ThirdLogin extends React.Component {
  handleThirdLogin(tp) {
    const { backurl = '/' } = this.props
    let backurl1 = backurl

    if (!/^http/.test(backurl)) {
      backurl1 = `${location.protocol}//${location.hostname}${backurl}`
    }

    log(tp)

    if (tp === 'mail') {
      window.location.href = `/login/mail?back_url=${encodeURIComponent(backurl1)}`
      return
    }

    const yd = YDLogin()
    yd.account.login(tp, backurl1 || '/', true)
  }

  render() {
    return (
      <div className={s.thirdPart}>
        <div className={s.header}>
          其他账号登录
        </div>
        <div className={s.btnBox}>
          <ThirdBtn
            handler={() => {
              this.handleThirdLogin('weixin-web-xue')
            }}
            imgUrl={weixinIcon}
          />
          <ThirdBtn
            handler={() => {
              this.handleThirdLogin('tsina')
            }}
            imgUrl={weiboIcon}
          />
          <ThirdBtn
            handler={() => {
              this.handleThirdLogin('cqq')
            }}
            imgUrl={qqIcon}
          />
          <ThirdBtn
            handler={() => {
              this.handleThirdLogin('mail')
            }}
            imgUrl={mailIcon}
          />
        </div>
      </div>
    );
  }
}
ThirdLogin.propTypes = {
  backurl: PropTypes.string.isRequired,
};

export default withStyles(s)(ThirdLogin);




// WEBPACK FOOTER //
// ./src/components/p_login/ThirdLogin/index.js